<template>
  <section class="page-breadcrumb" v-if="_title" :style="wstyle">
    <span class="breadcrumb-txt">{{ _title }}</span>
    <div class="extras" v-if="_extraTabs?.length > 0">
      <div class="item" :class="{ active: !!item.active }" v-for="(item, index) in _extraTabs" @click="$emit('extra', item)">{{ item?.label }}</div>
    </div>
    <slot></slot>
  </section>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';

  const props = defineProps({
    title: {
      type: String,
      default: ''
    },
    extraTabs: {
      type: Array,
      default: []
    },
    wstyle: {
      type: String,
      default: ''
    }
  })

  const _extraTabs = ref([])
  const _title = ref('')
  const init = () => {
    _extraTabs.value = props.extraTabs;
    _title.value = props.title;
  }
  onMounted(() => {
    init()
  })
  watch(() => props, () => {
    init()
  }, { deep: true })
</script>

<style scoped lang="less">
  @import "index.less";
</style>
